export enum TradingFeatures {
  Sider = "sider",
  TopNavBar = "topNavBar",
  Footer = "footer",
  Header = "header",
  Kline = "kline",
  OrderBook = "orderBook",
  TradeHistory = "tradeHistory",
  Positions = "positions",
  Orders = "orders",
  AssetAndMarginInfo = "asset_margin_info",
}
